/* SP Tools USA — Product page JS
 * Loads only on template == 'product'.
 * Replicates prototype behaviors (gallery thumbs, tabs, sticky ATC, FBT, wishlist stub)
 * while delegating cart, variant, and form logic to Dawn web components. */

(function () {
  'use strict';

  /* ----------------------------------------------------------
   * 1. Gallery thumb switcher
   *    Click thumb → swap main image, toggle active class.
   *    Works with theme-product-media-gallery.liquid's thumb markup.
   * ---------------------------------------------------------- */
  function initGalleryThumbs() {
    var thumbs = document.querySelectorAll('.product-gallery-thumb');
    var main = document.querySelector('.product-gallery-main img');
    if (!thumbs.length || !main) return;

    // Warm the browser cache with the full-size image for every thumb so the
    // swap is instant on click (otherwise each click triggers a fresh 1200px fetch).
    thumbs.forEach(function (thumb) {
      var src = thumb.dataset.src;
      if (!src) return;
      var pre = new Image();
      pre.decoding = 'async';
      pre.src = src;
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        var src = thumb.dataset.src || thumb.querySelector('img').src;
        var alt = thumb.dataset.alt || thumb.querySelector('img').alt || '';
        main.src = src;
        if (alt) main.alt = alt;
        thumbs.forEach(function (t) {
          t.classList.remove('product-gallery-thumb-active');
          t.removeAttribute('aria-current');
        });
        thumb.classList.add('product-gallery-thumb-active');
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ----------------------------------------------------------
   * 2. Product tabs
   *    Click tab → toggle .product-tab-active + .product-tab-panel-active.
   *    Hide tab if its panel has no content (data-empty="true").
   * ---------------------------------------------------------- */
  function initProductTabs() {
    var tabs = document.querySelectorAll('.product-tab');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      var panel = document.querySelector('[data-panel="' + tab.dataset.tab + '"]');
      if (panel && panel.dataset.empty === 'true') {
        tab.style.display = 'none';
        panel.style.display = 'none';
      }
    });

    var visibleTabs = Array.prototype.filter.call(tabs, function (t) {
      return t.style.display !== 'none';
    });
    var hasActive = visibleTabs.some(function (t) { return t.classList.contains('product-tab-active'); });
    if (!hasActive && visibleTabs.length) {
      visibleTabs[0].classList.add('product-tab-active');
      var firstPanel = document.querySelector('[data-panel="' + visibleTabs[0].dataset.tab + '"]');
      if (firstPanel) firstPanel.classList.add('product-tab-panel-active');
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('product-tab-active'); });
        document.querySelectorAll('.product-tab-panel').forEach(function (p) {
          p.classList.remove('product-tab-panel-active');
        });
        tab.classList.add('product-tab-active');
        var panel = document.querySelector('[data-panel="' + key + '"]');
        if (panel) panel.classList.add('product-tab-panel-active');
      });
    });
  }

  /* ----------------------------------------------------------
   * 3. Variant change → update sticky ATC + SKU row in spec table
   *    Listens for Dawn's variant:change event (dispatched by <variant-selects>).
   * ---------------------------------------------------------- */
  function initVariantChangeListeners() {
    var variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    function applyVariant(variant) {
      if (!variant) return;
      updateStickyAtc(variant);
      updateSkuRow(variant);
      updateSaveChip(variant);
    }

    // Prefer Dawn's post-fetch pub/sub event: it fires AFTER product-info.js has
    // fetched the new section and written the fresh [data-selected-variant] JSON.
    // A plain `change` listener runs before that fetch resolves and would read the
    // PREVIOUS variant's data (stale SKU / price / save chip until reload).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) {
          // Fall back to the JSON script if the payload lacks the variant.
          var script = variantSelects.querySelector('[data-selected-variant]');
          if (script) {
            try {
              variant = JSON.parse(script.textContent);
            } catch (e) { /* ignore */ }
          }
        }
        applyVariant(variant);
      });
      return;
    }

    // Fallback for markup without Dawn pub/sub — read the JSON after the DOM settles.
    variantSelects.addEventListener('change', function () {
      requestAnimationFrame(function () {
        var script = variantSelects.querySelector('[data-selected-variant]');
        if (!script) return;
        try {
          applyVariant(JSON.parse(script.textContent));
        } catch (e) { /* ignore parse error */ }
      });
    });
  }

  function updateStickyAtc(variant) {
    var titleEl = document.querySelector('.sticky-atc-title');
    var priceEl = document.querySelector('.sticky-atc-price');
    var imgEl = document.querySelector('.sticky-atc-media img');
    if (priceEl && typeof variant.price === 'number') {
      priceEl.textContent = formatMoney(variant.price);
    }
    if (imgEl && variant.featured_image && variant.featured_image.src) {
      imgEl.src = variant.featured_image.src;
    }
    if (titleEl && variant.name) {
      // Keep the product title; variant name appears after — leave title alone unless markup demands change
    }
  }

  function updateSaveChip(variant) {
    var chip = document.querySelector('[data-save-amount]');
    if (!chip) return;
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var save = variant.compare_at_price - variant.price;
      chip.textContent = 'Save ' + formatMoney(save);
      chip.style.display = '';
    } else {
      chip.style.display = 'none';
    }
  }

  function updateSkuRow(variant) {
    var skuCell = document.querySelector('[data-sku-row] td');
    if (skuCell && variant.sku) {
      skuCell.textContent = variant.sku;
    }
    var skuInline = document.querySelector('.product-detail-sku');
    if (skuInline && variant.sku) {
      var label = skuInline.dataset.label || 'SKU';
      skuInline.textContent = label + ': ' + variant.sku;
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* ----------------------------------------------------------
   * 4. Sticky ATC bar — show after main .product-detail-actions
   *    scrolls out of viewport. Mirror qty between main + sticky.
   * ---------------------------------------------------------- */
  function initStickyAtc() {
    var stickyAtc = document.querySelector('.sticky-atc');
    var mainActions = document.querySelector('.product-detail-actions');
    if (!stickyAtc || !mainActions || !('IntersectionObserver' in window)) return;

    var offset = parseInt(stickyAtc.getAttribute('data-offset'), 10);
    if (isNaN(offset) || offset < 0) offset = 40;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.boundingClientRect.top > 0) {
          stickyAtc.classList.remove('active');
          stickyAtc.setAttribute('aria-hidden', 'true');
        } else {
          stickyAtc.classList.add('active');
          stickyAtc.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -' + offset + 'px 0px' });

    observer.observe(mainActions);

    // Mirror qty: main → sticky and sticky → main
    var mainQty = document.querySelector('.product-detail-info .quantity__input');
    var stickyQty = document.querySelector('.sticky-atc-qty input');
    if (mainQty && stickyQty) {
      mainQty.addEventListener('input', function () { stickyQty.value = mainQty.value; });
      stickyQty.addEventListener('input', function () { mainQty.value = stickyQty.value; });
    }

    // Sticky qty buttons
    var stickyBtns = document.querySelectorAll('.sticky-atc-qty .qty-btn');
    stickyBtns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (!stickyQty) return;
        var v = parseInt(stickyQty.value, 10) || 1;
        stickyQty.value = i === 0 ? Math.max(1, v - 1) : v + 1;
        stickyQty.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });

    // Sticky ATC submit — fire the main form's submit event so Dawn's
    // <product-form> handler runs (cart drawer open + loading state + errors).
    // Button is type="button" so the browser never tries a native form-submit;
    // JS owns the whole flow.
    var stickyBtn = stickyAtc.querySelector('.sticky-atc-btn');
    var stickyPending = false;

    // Dawn renders add-to-cart validation errors into .product-form__error-message-wrapper
    // inside the main <product-form>, which sits far above the sticky bar. Bring it into
    // view so the user actually sees the rejection.
    function scrollToMainFormError(formEl) {
      var wrapper = formEl
        ? formEl.parentNode.querySelector('.product-form__error-message-wrapper')
        : document.querySelector('.product-form__error-message-wrapper');
      var target = wrapper && !wrapper.hasAttribute('hidden')
        ? wrapper
        : (formEl && formEl.querySelector('.product-form__submit'));
      if (target && typeof target.scrollIntoView === 'function') {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (stickyBtn.disabled) return;

        var formId = stickyBtn.getAttribute('data-form-id');
        var form = formId ? document.getElementById(formId) : null;
        if (!form) return;

        if (mainQty && stickyQty) {
          mainQty.value = stickyQty.value;
          mainQty.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // If Dawn's main submit is already locked (sold-out state from a prior
        // failed add), its onSubmitHandler bails at the aria-disabled check and
        // the click would be a silent no-op. Surface the existing error instead.
        var mainSubmit = form.querySelector('.product-form__submit');
        if (mainSubmit && (mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true')) {
          scrollToMainFormError(form);
          return;
        }

        stickyPending = true;

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      if (PUB_SUB_EVENTS.cartError) {
        subscribe(PUB_SUB_EVENTS.cartError, function (event) {
          if (!stickyPending) return;
          if (event && event.source !== 'product-form') return;
          stickyPending = false;
          var formId = stickyBtn && stickyBtn.getAttribute('data-form-id');
          var form = formId ? document.getElementById(formId) : null;
          // Defer one tick so handleErrorMessage has populated + unhidden the wrapper.
          setTimeout(function () { scrollToMainFormError(form); }, 0);
        });
      }
      if (PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { stickyPending = false; });
      }
    }
  }

  /* ----------------------------------------------------------
   * 5. Frequently Bought Together
   *    Checkbox toggle → recalc total + display discount.
   *    Submit → POST checked variant ids to /cart/add.js then open cart drawer.
   * ---------------------------------------------------------- */
  function initFbt() {
    var fbt = document.querySelector('.upsell');
    if (!fbt) return;

    var checkboxes = fbt.querySelectorAll('.upsell-check input[type="checkbox"]');
    var totalPriceEl = fbt.querySelector('.upsell-total-price');
    var strikeEl = fbt.querySelector('.upsell-total-strike');
    var submitBtn = fbt.querySelector('[data-fbt-submit]');
    var discountPct = parseFloat(fbt.dataset.discountPercent || '0') || 0;
    var mainVariantId = parseInt(fbt.dataset.mainVariantId || '0', 10) || 0;
    var mainPrice = parseFloat(fbt.dataset.mainPrice || '0') || 0;

    function recalc() {
      var sum = mainPrice;
      var checkedCount = 0;
      checkboxes.forEach(function (cb) {
        if (cb.checked) {
          checkedCount++;
          var p = parseFloat(cb.dataset.price || '0') || 0;
          sum += p;
        }
      });
      var discounted = sum * (100 - discountPct) / 100;
      if (totalPriceEl) {
        // Preserve the strike span in totalPriceEl
        var price = formatMoney(Math.round(discounted * 100));
        var strikeHtml = strikeEl ? strikeEl.outerHTML : '';
        totalPriceEl.innerHTML = price + ' ' + strikeHtml;
        if (strikeEl) {
          var newStrike = totalPriceEl.querySelector('.upsell-total-strike');
          if (newStrike) newStrike.textContent = formatMoney(Math.round(sum * 100));
        }
      }
      // Require at least one FBT item checked for the bundle to make sense.
      if (submitBtn) {
        submitBtn.disabled = checkedCount === 0;
        submitBtn.setAttribute('aria-disabled', checkedCount === 0 ? 'true' : 'false');
      }
    }

    checkboxes.forEach(function (cb) { cb.addEventListener('change', recalc); });
    recalc();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        mainPrice = variant ? (variant.price || 0) / 100 : 0;
        mainVariantId = variant ? (variant.id || 0) : 0;
        recalc();
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (submitBtn.disabled) return;
        var items = [];
        if (mainVariantId) {
          items.push({ id: mainVariantId, quantity: 1 });
        }
        var anyChecked = false;
        checkboxes.forEach(function (cb) {
          if (cb.checked && cb.dataset.variantId) {
            anyChecked = true;
            items.push({ id: parseInt(cb.dataset.variantId, 10), quantity: 1 });
          }
        });
        if (!anyChecked) return;
        submitBtn.disabled = true;
        var origText = submitBtn.innerHTML;
        submitBtn.textContent = 'Adding…';

        // Dawn cart-drawer is mounted only when settings.cart_type == 'drawer'.
        // When present, ask /cart/add.js to return the sections we need to
        // re-render, then hand the parsed response to drawer.renderContents
        // (which itself calls drawer.open() in a setTimeout).
        var drawer = document.querySelector('cart-drawer');
        var body = { items: items };
        if (drawer && typeof drawer.renderContents === 'function') {
          var sectionIds = (typeof drawer.getSectionsToRender === 'function')
            ? drawer.getSectionsToRender().map(function (s) { return s.id; })
            : ['cart-drawer', 'cart-icon-bubble'];
          body.sections = sectionIds;
          body.sections_url = window.location.pathname;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (parsedState) {
            if (parsedState && parsedState.status) {
              // Shopify returns { status, message, description } on failure.
              throw new Error(parsedState.description || parsedState.message);
            }
            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.renderContents(parsedState);
            } else {
              // Cart type is 'page' (or drawer missing) — fall back to /cart.
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function () { /* swallow — could surface a toast here later */ })
          .finally(function () {
            submitBtn.innerHTML = origText;
            // Restore correct disabled state based on current checkbox selection.
            recalc();
          });
      });
    }
  }

  /* ----------------------------------------------------------
   * 6. Wishlist visual stub
   *    Click heart → toggle ph (outline) ↔ ph-fill (filled).
   * ---------------------------------------------------------- */
  function initWishlistStub() {
    var triggers = document.querySelectorAll('[data-wishlist-toggle]');
    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var icon = t.querySelector('i.ph, i.ph-fill, i.ph-bold');
        if (!icon) return;
        if (icon.classList.contains('ph-fill')) {
          icon.classList.remove('ph-fill');
          icon.classList.add('ph');
          t.setAttribute('aria-pressed', 'false');
        } else {
          icon.classList.remove('ph');
          icon.classList.remove('ph-bold');
          icon.classList.add('ph-fill');
          t.setAttribute('aria-pressed', 'true');
        }
      });
    });
  }

  /* ----------------------------------------------------------
   * Init on DOM ready
   * ---------------------------------------------------------- */
  function init() {
    initGalleryThumbs();
    initProductTabs();
    initVariantChangeListeners();
    initStickyAtc();
    initFbt();
    initWishlistStub();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
